import { useState, useEffect } from "react";
import { SelectorInputTypeProps } from "../Interface";
import { toast } from "sonner";
import { AxiosResponse } from "axios";

/**
 * A custom hook that provides the selector component an easy way to update the value
 * After the user updates the value, the api_callback is called to update the value in the database
 * 
 * @param value - The current value of the selector
 * @param api_callback - The API callback once the user updates the value
 * @returns The selector component
 */
export function useSelector(value: SelectorInputTypeProps, api_callback: (field_name: string, value: SelectorInputTypeProps) => Promise<AxiosResponse>) {
    const [input_value, setInputValue] = useState<SelectorInputTypeProps>(value)
    const [open, setOpen] = useState<boolean>(false)

    const updateValue = async (field_name: string, value: SelectorInputTypeProps) => {
        console.log("Updating value: (This is from the useSelector hook) ", value)

        try {
            await api_callback(field_name, value)
            toast.success("Value updated successfully")

            // Convert date string to local date format if it's a date, otherwise set value directly
            if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}$/)) {
                setInputValue(new Date(value + 'T00:00:00').toLocaleDateString())
            } else {
                setInputValue(value)
            }

            console.log("Value updated successfully (This is from the useSelector hook)")
        } catch (error) {
            toast.error("Error updating value")
            console.error("Error updating value (This is from the useSelector hook)", error)
        }
    }

    const setValue = (value: SelectorInputTypeProps) => {
        setInputValue(value)
    }

    useEffect(() => {
        setInputValue(value)
    }, [value])
    
    return {
        // State
        input_value,
        open,

        // Functions
        setOpen,
        updateValue,
        setValue,
    }
}